(function(){
  if(window.__hokeeCartConversionLoaded) return;
  window.__hokeeCartConversionLoaded=true;

  var threshold=4900;
  var lastSignature='';
  var lastState=null;
  var timer=null;
  var refreshing=false;

  function money(cents){
    var currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
    var locale=document.documentElement.lang||'fr-FR';
    try{return new Intl.NumberFormat(locale,{style:'currency',currency:currency}).format(cents/100);}catch(e){return (cents/100).toFixed(2).replace('.',',')+' €';}
  }

  function cartState(cart){
    var total=Number(cart&&cart.total_price)||0;
    return {
      count:Number(cart&&cart.item_count)||0,
      total:total,
      remaining:Math.max(threshold-total,0),
      percent:Math.min(Math.round((total/threshold)*100),100),
      unlocked:total>=threshold
    };
  }

  function createBlock(state){
    var wrapper=document.createElement('div');
    wrapper.className='hk-cart-conversion';
    wrapper.dataset.hokeeCart='true';
    var message=state.unlocked
      ? '<strong>Livraison offerte débloquée</strong> pour la France métropolitaine'
      : 'Plus que <strong>'+money(state.remaining)+'</strong> pour profiter de la livraison offerte';
    wrapper.innerHTML='<p class="hk-cart-conversion__message"><span aria-hidden="true">✦</span><span>'+message+'</span></p><div class="hk-cart-conversion__track" role="progressbar" aria-label="Progression vers la livraison offerte" aria-valuemin="0" aria-valuemax="100" aria-valuenow="'+state.percent+'"><span class="hk-cart-conversion__bar" style="width:'+state.percent+'%"></span></div><div class="hk-cart-conversion__trust" aria-label="Nos garanties"><span><b aria-hidden="true">🔒</b>Paiement sécurisé</span><span><b aria-hidden="true">📦</b>Expédition depuis la France</span><span><b aria-hidden="true">↩</b>Retours sous 14 jours</span></div>';
    return wrapper;
  }

  function createGlobalBar(){
    var bar=document.createElement('button');
    bar.type='button';
    bar.className='hk-cart-progress-global';
    bar.setAttribute('data-hk-cart-progress-global','');
    bar.setAttribute('aria-label','Voir le panier et la progression vers la livraison offerte');
    bar.setAttribute('aria-hidden','true');
    bar.innerHTML='<span class="hk-cart-progress-global__icon" aria-hidden="true">✦</span><span class="hk-cart-progress-global__content"><span class="hk-cart-progress-global__message"></span><span class="hk-cart-progress-global__track" role="progressbar" aria-label="Progression vers la livraison offerte" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"><span></span></span></span><span class="hk-cart-progress-global__action">Voir le panier</span>';
    bar.addEventListener('click',openCart);
    document.body.appendChild(bar);
    return bar;
  }

  function openCart(){
    var cartIcon=document.querySelector('#cart-icon-bubble');
    if(cartIcon){cartIcon.click();setTimeout(syncGlobalVisibility,120);return;}
    window.location.href=(window.routes&&window.routes.cart_url)||'/cart';
  }

  function drawerIsOpen(){
    var drawer=document.querySelector('#CartDrawer');
    return !!(drawer&&(drawer.classList.contains('active')||drawer.hasAttribute('open')));
  }

  function onCartPage(){
    return window.location.pathname.replace(/\/$/,'')===((window.routes&&window.routes.cart_url)||'/cart').replace(/\/$/,'')||document.body.classList.contains('template-cart');
  }

  function syncGlobalVisibility(){
    var bar=document.querySelector('[data-hk-cart-progress-global]');
    if(!bar||!lastState) return;
    var show=lastState.count>0&&!onCartPage()&&!drawerIsOpen();
    bar.classList.toggle('is-visible',show);
    bar.setAttribute('aria-hidden',show?'false':'true');
  }

  function updateGlobal(state){
    var bar=document.querySelector('[data-hk-cart-progress-global]')||createGlobalBar();
    var message=bar.querySelector('.hk-cart-progress-global__message');
    var track=bar.querySelector('.hk-cart-progress-global__track');
    var fill=track&&track.querySelector('span');
    bar.classList.toggle('is-unlocked',state.unlocked);
    if(message){
      message.innerHTML=state.unlocked
        ? '<strong>Livraison offerte débloquée</strong>'
        : 'Plus que <strong>'+money(state.remaining)+'</strong> pour la livraison offerte';
    }
    if(track) track.setAttribute('aria-valuenow',String(state.percent));
    if(fill) fill.style.width=state.percent+'%';
    syncGlobalVisibility();
  }

  function ensurePaymentNote(container){
    if(!container||container.querySelector('.hk-cart-payment-note')) return;
    var note=document.createElement('p');
    note.className='hk-cart-payment-note';
    note.innerHTML='<strong>Commande protégée</strong> · Paiement chiffré et sécurisé';
    container.appendChild(note);
  }

  function enhance(cart){
    var state=cartState(cart);
    var signature=String(state.count)+'|'+String(state.total);
    var targets=[];
    var page=document.querySelector('#main-cart-footer .cart__blocks');
    var drawer=document.querySelector('#CartDrawer .drawer__footer');
    if(page) targets.push(page);
    if(drawer) targets.push(drawer);

    targets.forEach(function(target){
      var old=target.querySelector(':scope > .hk-cart-conversion');
      if(state.count===0){if(old) old.remove();return;}
      if(!old||signature!==lastSignature){
        var fresh=createBlock(state);
        if(old) old.replaceWith(fresh); else target.prepend(fresh);
      }
    });

    document.querySelectorAll('#checkout,#CartDrawer-Checkout').forEach(function(button){
      if(button.textContent.trim()!=='Passer au paiement sécurisé') button.textContent='Passer au paiement sécurisé';
      ensurePaymentNote(button.closest('.cart__ctas'));
    });

    lastState=state;
    lastSignature=signature;
    updateGlobal(state);
  }

  function refresh(){
    if(refreshing) return;
    refreshing=true;
    fetch(((window.routes&&window.routes.cart_url)||'/cart')+'.js',{headers:{Accept:'application/json'},cache:'no-store',credentials:'same-origin'})
      .then(function(response){if(!response.ok) throw new Error('Cart fetch failed');return response.json();})
      .then(enhance)
      .catch(function(){})
      .then(function(){refreshing=false;});
  }

  function schedule(delay){
    clearTimeout(timer);
    timer=setTimeout(refresh,typeof delay==='number'?delay:160);
  }

  function bindCartEvents(){
    if(typeof window.subscribe==='function'&&window.PUB_SUB_EVENTS&&window.PUB_SUB_EVENTS.cartUpdate){
      try{window.subscribe(window.PUB_SUB_EVENTS.cartUpdate,function(){schedule(80);});}catch(e){}
    }
    ['cart:updated','cart:refresh','product:added'].forEach(function(name){document.addEventListener(name,function(){schedule(80);});});
    document.addEventListener('click',function(event){
      if(event.target.closest('button[name="add"],.quick-add__submit,.quantity__button,cart-remove-button,#cart-icon-bubble,.drawer__close')){
        schedule(350);
        setTimeout(syncGlobalVisibility,120);
      }
    });
    document.addEventListener('change',function(event){
      if(event.target.matches('input[name="updates[]"],.quantity__input')) schedule(250);
    });
  }

  function observeDrawer(){
    var drawer=document.querySelector('#CartDrawer');
    if(!drawer) return;
    new MutationObserver(syncGlobalVisibility).observe(drawer,{attributes:true,attributeFilter:['class','open']});
  }

  function init(){
    bindCartEvents();
    observeDrawer();
    schedule(0);
    document.addEventListener('shopify:section:load',function(){observeDrawer();schedule(50);});
    window.addEventListener('pageshow',function(){schedule(50);});
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
